import { render, staticRenderFns } from "./TemplateSelect.vue?vue&type=template&id=6396b138&"
import script from "./TemplateSelect.vue?vue&type=script&lang=ts&"
export * from "./TemplateSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports